















import Vue from 'vue'

export default Vue.extend({
  name: 'AppBar',

  methods: {
    viewNotes() {
      if (this.$router.currentRoute.name === 'Notes') {
        return
      }
      this.$router.push({
        name: 'Notes'
      })
    },
    writeText() {
      if (this.$router.currentRoute.name === 'WriteText') {
        return
      }
      this.$router.push({
        name: 'WriteText'
      })
    }
  }
})
